(function() {
  function initWrapper(tabsWrapper) {
    var tabs = tabsWrapper.querySelectorAll('.filter-tab');
    if (!tabs.length) return;

    function getRoot() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return '/';
    }

    function findGrid() {
      var rect = tabsWrapper.getBoundingClientRect();
      var tabsY = rect.top + window.scrollY;

      var grids = document.querySelectorAll('.resource-list--grid, [class*="resource-list"][class*="grid"]');
      for (var i = 0; i < grids.length; i++) {
        var g = grids[i];
        var gRect = g.getBoundingClientRect();
        if (gRect.top + window.scrollY > tabsY && g.querySelector('product-card, [class*="product-card"]')) {
          return g;
        }
      }
      console.warn('[FilterTabs] No grid found after tabs for', tabsWrapper.dataset.tabsId);
      return null;
    }

    function extractItemsFromDoc(doc) {
      var items = doc.querySelectorAll('.resource-list__item');
      if (items.length > 0) return Array.from(items);
      var cards = doc.querySelectorAll('product-card, [class*="product-card"]');
      var wrappers = [];
      cards.forEach(function(c) {
        var w = c.closest('.resource-list__item, li, [class*="grid-item"]');
        if (w && wrappers.indexOf(w) === -1) wrappers.push(w);
        else if (!w) wrappers.push(c);
      });
      return wrappers;
    }

    async function loadCollection(handle, tab) {
      var grid = findGrid();
      if (!grid) {
        alert('Could not find product grid');
        return;
      }

      tabs.forEach(function(t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active', 'is-loading');
      grid.classList.add('filter-tabs-loading-target');

      try {
        var url = getRoot() + 'collections/' + handle;
        var res = await fetch(url, { headers: { 'Accept': 'text/html' } });
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        var html = await res.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var items = extractItemsFromDoc(doc);
        if (!items.length) {
          alert('No products found in /collections/' + handle);
          return;
        }

        var newHTML = items.map(function(item) { return item.outerHTML; }).join('');
        grid.innerHTML = newHTML;
        console.log('[FilterTabs:' + (tabsWrapper.dataset.tabsId || 'unnamed') + '] Loaded ' + items.length + ' products');

      } catch (err) {
        console.error('[FilterTabs] Error:', err);
        alert('Error: ' + err.message);
      } finally {
        tab.classList.remove('is-loading');
        grid.classList.remove('filter-tabs-loading-target');
      }
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        var handle = tab.dataset.collection;
        if (!handle) return;
        if (tab.classList.contains('is-active') && !tab.classList.contains('is-loading')) return;
        loadCollection(handle, tab);
      });
    });
  }

  function init() {
    var allWrappers = document.querySelectorAll('.filter-tabs-wrapper');
    if (!allWrappers.length) return;
    allWrappers.forEach(initWrapper);
    console.log('[FilterTabs] Initialized', allWrappers.length, 'wrapper(s)');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();